module.exports = __webpack_public_path__ + "img/gwnu_gallery4.d936202a.jpg";